import React from 'react';
import './AboutUs.css'; // Add custom styles if needed

const AboutUs = () => {
  return (
    <div className="about-us-container">
      
      <h1>About Us</h1>
      <p>
        Welcome to <strong>CommentInsight</strong>, your ultimate partner in understanding your audience and growing your YouTube channel with data-driven insights!
      </p>
      <p>
        As a YouTuber, you pour time, creativity, and energy into crafting content that resonates with your viewers. But how do you know if your efforts truly hit the mark? What are your viewers loving? What needs a tweak? With thousands of comments pouring in, it’s hard to uncover what your audience really thinks—until now.
      </p>
      
      <h2>What is CommentInsight?</h2>
      <p>
        CommentInsight is a cutting-edge AI-powered tool designed to help YouTubers analyze and decode their viewers' feedback. Our platform processes comments in <strong>multiple languages</strong>, categorizes feedback, and delivers actionable insights—all in one intuitive dashboard.
      </p>
      <p>
        Whether you’re building your channel or managing millions of subscribers, CommentInsight ensures you never miss what your audience is saying.
      </p>

      <h2>Why Use CommentInsight?</h2>
      <h3>1. <strong>Uncover What Works</strong></h3>
      <ul>
        <li>Pinpoint what your viewers love the most about your videos—be it your storytelling, editing style, or even that witty intro.</li>
        <li>Identify patterns in positive feedback to double down on the elements that bring your audience back for more.</li>
      </ul>
      <h3>2. <strong>Spot Opportunities for Growth</strong></h3>
      <ul>
        <li>Analyze critical comments to learn where you can improve.</li>
        <li>Understand why some videos perform better than others, helping you refine your content strategy.</li>
      </ul>
      <h3>3. <strong>Stay Multilingual</strong></h3>
      <p>
        With our <strong>multilingual support</strong>, you can connect with a global audience. Understand comments in any language and make your content inclusive for all.
      </p>
      <h3>4. <strong>Save Time, Focus on Creation</strong></h3>
      <p>
        No more spending hours sifting through thousands of comments. CommentInsight does the heavy lifting, so you can focus on what you do best—creating amazing content.
      </p>

      <h2>How It Works</h2>
      <ol>
        <li><strong>Upload or Link Your Video:</strong> Paste your video link, and let CommentInsight work its magic.</li>
        <li><strong>AI-Powered Analysis:</strong> Our generative AI dives deep into your comments, classifying them as positive, constructive, or critical.</li>
        <li><strong>Get Actionable Insights:</strong> Receive an easy-to-read report highlighting viewer sentiment, trending feedback, and actionable suggestions.</li>
        <li><strong>Refine Your Strategy:</strong> Use the insights to craft content that your audience truly loves.</li>
      </ol>

      <h2>Why We Built CommentInsight</h2>
      <p>
        At CommentInsight, we believe that <strong>feedback fuels growth</strong>. We know how challenging it can be to truly understand your audience’s needs when you’re juggling content creation, uploads, and engagement.
      </p>
      <p>Our mission is simple:</p>
      <ul>
        <li>To empower creators with <strong>clarity</strong>.</li>
        <li>To make understanding feedback <strong>seamless</strong>.</li>
        <li>To help you achieve <strong>unparalleled audience connection</strong>.</li>
      </ul>
      <p>
        By giving you the tools to listen better, we’re helping you make your channel the best it can be—one video at a time.
      </p>

      <h2>Join the Revolution</h2>
      <p>
        Thousands of YouTubers are already using CommentInsight to:
      </p>
      <ul>
        <li>Create content their audience loves.</li>
        <li>Improve their video performance.</li>
        <li>Build stronger, more engaged communities.</li>
      </ul>
      <p>
        It’s time to take your channel to the next level.  
        <strong> Ready to unlock your audience’s voice?</strong>
      </p>

      <a href="https://commentinsight.onrender.com" className="cta-button">
        Start Now with CommentInsight
      </a>

      <h2>Final Thought</h2>
      <p>
        You create the content, and we’ll help you make it perfect for your audience. Let’s make every comment count!
      </p>
    </div>
  );
};

export default AboutUs;
